var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"submit-button-container"},[_c('button',{staticClass:"submit-button",attrs:{"disabled":_vm.isButtonDisabled,"type":"button"},on:{"click":_vm.onClick}},[(_vm.isLoading)?[_c('div',{staticClass:"spinner submit-button__spinner"})]:[_vm._v("Забронировать")]],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }